<template>
    <div class="sku">
        <!-- 规格modal -->
        <div class='layer' v-show='sku_show' @click='isSku'></div>
        <div class='model' v-show='sku_show'>
            <div class='model__info'>
                <img :src='product.cover_img'>
                <div class='flex__null__between model__info__right'>
                    <div class='flex__between__center'>
                        <div>
                            <span class='fs_24 c_main'>¥</span>
                            <span class='fs_32 c_main'>{{product.price}}</span>
                        </div>
                        <span class='jcicon jcicon-error c_b3' @click='isSku'></span>
                    </div> 
                    <span class='fs_24 c_98'>库存：{{product.stock}}</span>
                    <span v-if="product_spec.length" class='fs_24 c_98'>已选规格：{{sku_name}}</span>
                </div>
            </div>
            <div class="model__spec-box">
                <div class='model__spec' v-for="(item,index) in product_spec" :key="index ">
                    <span class='fs_28 c_33'>{{item.spec_title}}</span>
                    <div class='flex wrap '>
                        <div 
                        v-for="(item1,index1) in item.spec_item" 
                        :key="index1" 
                        @click="switchSpec(index,index1)">
                            <div class="model__spec__item" :class="[item1.active?'active':'',item1.apply?'actives':'']">{{item1.spec_item_value}}</div>
                        </div>
                    </div>
                </div>
                <div class='flex__between__center model__num'>
                    <span class='fs_28 c_33'>数量</span>
                    <div class='stepper_components'>
                        <div class='count' @click='reduce'>
                            <span class='jcicon jcicon-jianhaocu c_4d fs_22'></span>
                        </div>
                        <div class='count count--big'>
                            <span class='fs_24'>{{orders.number}}</span>
                        </div>
                        <div class='count' @click='add'>
                            <span class='jcicon jcicon-jiahao c_4d fs_22'></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class='model__footer' @click="sure">
                <button>确定</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Sku',
    data(){
        return{
            product:{
                img_path:[]
            },
            product_spec: [],
            orders:{
                user_id:localStorage.user_id,
                number: 1,
                order_type:2,
                product_id: '',
                group_id: '',
                product_sku: ''
            },
            show: false, //规格modal
            sku_name: '请选择',
            sku_arr: [], //选中规格id数组
        }
    },
    props:{
        sku_show:{
            type: Boolean
        },
        product_id:{
            type: Number
        },
        group_id:{
            type: Number
        }
    },
    methods:{
        isSku(){
            this.$emit('isSku',false);
        },
       // 选择规格 (下级规格 往里面push)
        switchSpec(index,index1) {
            // 判断当前是否还有库存
            if (this.product_spec[index].spec_item[index1].apply) {
                this.$toast('库存不足');
                return;
            }

            let product_sku = this.product_sku;//匹配规格数据
            let product_spec = this.product_spec;//规格列表
            let sku_arr = this.sku_arr;//选中规格
            sku_arr[index] = product_spec[index].spec_item[index1];
            let chose_sku = sku_arr.concat();//选中规格id,副本
            // 选中或取消
            if (product_spec[index].spec_item[index1].active) {
                this.initial();
                // 取消 去掉样式
                product_spec[index].spec_item[index1].active = false;
                chose_sku.splice(index, 1,'');
                for(let i=0;i<chose_sku.length;i++){
                    if(chose_sku[i]){
                        this.proving(chose_sku[i].spec_item_id,res=>{
                            this.splitCheck(res,i);
                        }) 
                    }
                }
            } else {
                //清空当前行选中规格
                for (let i = 0; i < product_spec[index].spec_item.length; i++) {
                    product_spec[index].spec_item[i].active = false;
                }
                product_spec[index].spec_item[index1].active = true;
                this.proving(chose_sku[index].spec_item_id,res=>{
                    this.splitCheck(res,index);
                })  
            }

            let sku_code_str = ''; //副数组转为的字符串
            let chose_sku_vic=[];
            let chose_sku_name=[];
            let sku_name = '';//规格名称
            let product = this.product;
            let check_length=true;
            for(let i=0;i<chose_sku.length;i++){
                if(!chose_sku[i]){
                    check_length=false;
                    break;
                }
            }
            // 规格选全
            if (chose_sku.length == product_spec.length&&check_length) {
                for(let i=0;i<chose_sku.length;i++){
                    chose_sku_vic.push(chose_sku[i].spec_item_id);
                    chose_sku_name.push(chose_sku[i].spec_item_value);
                }
                sku_code_str=chose_sku_vic.sort().join('_');
                sku_name=chose_sku_name.join(',');
                for (let key in product_sku) {
                    if (key == sku_code_str) {
                        product.price = product_sku[key].price;
                        product.cover_img = product_sku[key].cover_img;
                        product.stock = product_sku[key].stock;
                        this.orders.product_sku = sku_code_str;
                    }
                }
            } else {
                product.price = this.product_vic.price;
                product.cover_img = this.product_vic.cover_img;
                sku_name = '请选择';
                product.stock = this.product_vic.stock;
                this.orders.product_sku = sku_code_str;
            }
            this.sku_arr=chose_sku;
            this.product_spec=product_spec;
            this.product=product;
            this.sku_name=sku_name;
        },
        // 初始
        initial(){
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            this.splitCheck(being_item);
        },
        // 返回有当前item_id的
        proving(spec_item_id, callback) {
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (key.indexOf(spec_item_id) != -1&&product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            callback(being_item);
        },
        //拆分赋值
        splitCheck(being_item,index){
            let product_spec = this.product_spec;
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        product_spec[i].spec_item[j].apply = true;
                    }
                }
            }
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        for(let m = 0; m < being_item.length; m++){
                            if(being_item[m]==product_spec[i].spec_item[j].spec_item_id){
                                product_spec[i].spec_item[j].apply = false;
                                break;
                            }
                        }
                    }
                }
            }
        },
        // 对象深度克隆 
        cloneObj(obj){
            let str, newobj = obj.constructor === Array ? [] : {};
            if(typeof obj !== 'object'){
                return;
            } else if (JSON) {
                str = JSON.stringify(obj), //序列化对象
                newobj = JSON.parse(str); //还原
            } else {//如果不支持以上方法
                for (let i in obj) {
                    newobj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i];
                }
            }
            return newobj;
        },
        // 减
        reduce() {
            if (this.sku_arr.length != this.product_spec.length){
                this.$toast('请选择规格');
                return;
            }
            if (this.orders.number > 1) {
                this.orders.number=this.orders.number - 1;
            } else {
                this.$toast('不能再减了');
            }
        },
        // 加
        add() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            if (!this.product.stock) {
                this.orders.number=this.orders.number + 1;
            } else if (this.orders.number < this.product.stock) {
                this.orders.number=this.orders.number + 1;
            }else{
                this.orders.number=this.product.stock;
                this.$toast('库存不足' + this.product.stock);
            }
        },
        // 下单
        sure() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            // 参团
            this.axios.post('/wechat.php/Collage/getOrderReady', this.orders).then(
                res => {
                    if (res.data.code == 1) {
                        this.$router.push({path:'/Assemble/Order',query: {
                            product_id:this.orders.product_id,
                            number: this.orders.number,
                            sku:this.orders.product_sku,
                            group_id: this.orders.group_id,
                            order_type:2}})
                    }else{
                        this.$toast(res.data.message);
                    }
            })
        }
    },
    mounted(){
        this.orders.group_id=this.group_id;
        this.axios.post('/wechat.php/Collage/getProductDetailData',{
            user_id: localStorage.user_id,
            product_id: this.product_id
        }).then(
            res=>{
                if(res.data.code==1){
                    this.orders.product_id=res.data.data.product.id;
                    this.product_sku=res.data.data.product_sku;
                    this.product=res.data.data.product;
                    this.product_vic=this.cloneObj(res.data.data.product);
                    this.product_spec=res.data.data.product_spec;
                }
            }
        )
    }
}
</script>

<style scoped>
.swiper-box img{
    width:750px;
    height:600px;
}
.info-box{
    position: relative;
    padding: 25px 30px 25px;
    background: #fff;
}
/* 倒计时 */
.timing-box{
    height: 80px;
    padding: 0 15px;
    margin-top: 20px;
    background: #FAF2ED;
}
.timing-tips{
    min-width: 48px;
    height: 48px;
    padding: 0 8px;
    background: #1a1a1a;
    border-radius:6px;
    text-align: center;
    line-height: 48px;
}
.publicity{
    height: 80px;
    padding: 0 30px;
    border-top: 2px solid #e6e6e6;
    background: #fff;
}
.share-box{
    position: absolute;
    bottom: 25px;
    right: 0;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px 0 0 20px;
    background: #f0f0f0;
}
/* 模块 */
.modular{
    margin-top: 15px;
    padding: 0 30px 0;
    background: #fff;
}
.modular__title{
    padding: 30px 0;
}
.modular__content{
    padding-bottom:30px;
}
.evaluate__item{
    padding-bottom: 30px;
}
.item__header img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.item__img img{
    width: 165px;
    height: 165px;
    margin: 10px 0 0 10px;
}
.item__img img:nth-child(4n+1){
    margin-left: 0;
}
.item__reply{
    padding: 10px 20px;
    background: #f5f5f5;
    border-radius: 10px;
}
.modular__footer{
    height: 90px;
    border-top: 2px solid #e6e6e6;
}
.null-box{
    border-top: 2px solid #e6e6e6;
    height: 90px;
}

/* 拼团 */
.regiment-box{
    margin-top: 15px;
    background: #fff;
}
.regiment__header{
    height: 100px;
    padding: 0 30px;
    border-bottom: 2px solid #e6e6e6;
}
.regiment__item{
    height: 130px;
    padding: 0 30px;
}
.regiment__item button{
    width:130px;
    height:60px;
    margin-left: 30px;
    border-radius:4px;
    background: #F93A42;
    font-size: 28px;
    color: #fff;
}
.regiment__item img{
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

/* modal */
.layer{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.ensure{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 3;
    background: #fff;
}
.ensure__content{
    padding: 30px;
}
.ensure-item{
    height: 130px;
    border-top: 2px solid #e6e6e6;
}
.ensure-item:nth-child(2){
    border: 0;
}
.ensure-item img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.ensure-item__right{
    height: 60px;
    margin-left: 20px;
}
.close-btn{
    width: 100%;
    height: 98px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    z-index: 1;
}
.footer__left,.footer__right{
    width: 50%;
    height: 98px;
}
.footer__left{
    background: #333;
}
.footer__right{
    position: relative;
    background: #F93A42;
}
.footer__right__item{
    position: absolute;
    width: 100%;
    height: 98px;
}
.btn-layer{
    position: absolute;
    width: 100%;
    height: 98px;
    background: #fff;
    opacity: 0.6;
}

/* 规格model */
.model{
  position: fixed;
  bottom: 0;
  z-index: 3;
  width: 100%;
  background: #fff;
}
.model__info{
  display: flex;
  padding: 30px 30px 0;
}
.model__info img{
  display: block;
  width: 220px;
  height: 220px;
  margin-top: -60px;
  border: 2px solid #E6E6E6;
  border-radius: 10px;
  background: #fff;
}
.model__info__right{
  width: 440px;
  margin-left: 30px;
}
.size-table{
  width: 120px;
  height: 30px;
  background: #1a1a1a;
  line-height: 30px;
}
.model__spec-box{
    max-height: 700px;
    padding: 0 30px;
    margin: 10px 0;
    overflow: auto;
}
.model__spec{
  padding: 30px 0;
  border-bottom: 2px solid #e6e6e6;
}
.model__spec__item{
    min-width: 60px;
    margin: 20px 20px 0 0;
    padding: 0 20px;
    height: 60px;
    line-height: 56px;
    text-align: center;
    font-size: 26px;
    color: #989898;
    border: 2px solid #CBCBCB;
    border-radius: 6px;
}
.active{
    color: #F93A42;
    border: 2px solid #F93A42;
}
.actives{
    background: #e8e8e8;
    color: #c8c9cc;
    border: none;
}
.model__num{
    height: 120px;
}
/* 计步器 */
.stepper_components{
    display: flex;
    justify-content: space-between;
    width: 200px;
    border: 2px solid #e6e6e6;
}
.stepper_components .count{
    width: 66px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.stepper_components .count--big{
    width: 85px;
    height: 60px;  
    border-right: 2px solid #e6e6e6;
    border-left: 2px solid #e6e6e6;
    text-align: center;
}
.model__footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/hzjc/sku/Index.vue